import { Suspense, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { DashboardHeader } from "@/features/Government Observer/dashboard-header";
import { DashboardShell } from "@/features/Government Observer/dashboard-shell";
import { AnimalDetailDashboard } from "@/features/Government Observer/animal-detail-dashboard";
import { DashboardSkeleton } from "@/features/Government Observer/dashboard-skeleton";
import { getAnimalById } from "@/lib/data";

export function AnimalDetailPage() {
  const { id } = useParams<{ id: string | undefined }>();
  const [animal, setAnimal] = useState<any | null>(null);

  useEffect(() => {
    if (!id) {
      return;
    }
    getAnimalById(id).then((data) => {
      setAnimal(data);
    });
  }, [id]);

  if (!animal) {
    return <div>Animal not found</div>;
  }

  return (
    <div className="w-full flex min-h-screen flex-col">
      <DashboardHeader />
      <DashboardShell>
        <Suspense fallback={<DashboardSkeleton />}>
          <AnimalDetailDashboard animalId={id} />
        </Suspense>
      </DashboardShell>
    </div>
  );
}
